import { FlexRow } from '@/components/common/Flex';
import { HourGlass01 } from '@/components/common/icons';
import { groupHoverStyleProps } from '@/components/common/styleHelpers';

export const LongFetchTimeIndicator = () => {
    return (
        <FlexRow>
            <HourGlass01
                color="gray.500"
                size="sm"
                ml={2}
                {...groupHoverStyleProps({
                    color: 'blue.500',
                })}
            />
        </FlexRow>
    );
};
